import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { UnionIcon } from '@gem/icons';
import { popupItemStyles } from '@gem/ui-kit';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';
import { VerifiedBadge } from 'APP/components/VerifiedBadge/VerifiedBadge';
import useUserOnlineStatusText from 'APP/main/hooks/userOnlineStatusText';
import { User } from 'STORE/Users/User/User';

import styles from './UserWithCheckbox.styles.m.css';

interface IUserWithCheckboxProps {
  getIsSelected(user: User): boolean;
  toggleUser(user: User): void;
  user: User;
}

export const UserWithCheckbox: FC<IUserWithCheckboxProps> = observer(
  ({ getIsSelected, toggleUser, user }) => {
    const subtitle = useUserOnlineStatusText({ user });

    const classes = classNames(popupItemStyles.container, popupItemStyles.interactive);

    const isSelected = getIsSelected(user);

    const checkboxClass = classNames(styles.checkboxView, {
      [styles.selected]: isSelected,
    });

    return (
      <label className={classes}>
        <PopupInfoCard
          type={AvatarTypes.Round_10}
          className={popupItemStyles.card}
          avatarTitle={user.avatarTitle || user.nickName}
          avatarUrl={user.avatarUrl || ''}
          avatarBackgroundColorIndex={user.avatarColorIndex}
          title={user.displayName}
          subtitle={subtitle}
          badge={user.verified && <VerifiedBadge />}
        />
        <div className={checkboxClass}>
          <input
            type="checkbox"
            className={styles.checkbox}
            onChange={(): void => toggleUser(user)}
            checked={isSelected}
          />
          {isSelected && <UnionIcon />}
        </div>
      </label>
    );
  }
);
